// This map is different from the Core:
// The Hotels have a markercluster
// The markerclusters are different
// The map center is not reading the FB Option, is calculated automatically to center with the different points
// No categories
// The excursions also have the same cluster


var mapBlock = document.getElementById('map');
if (mapBlock != null) {
    // Prevent load of Roboto in the map
    // var head = document.getElementsByTagName('head')[0];
    // var insertBefore = head.insertBefore;
    //
    // // Replace it
    // head.insertBefore = function (newElement, referenceElement) {
    //     if (newElement.href && newElement.href.indexOf('//fonts.googleapis.com/css?family=Roboto') > -1 ||
    //         newElement.href && newElement.href.indexOf('//fonts.googleapis.com/css?family=Google+Sans+Text') > -1
    //     ) {
    //         // Added Google+Sans+Text to avoid flashing after is loaded
    //         return;
    //     }
    //     insertBefore.call(head, newElement, referenceElement);
    // };
    // // End code Roboto


    var map;
    var markers = [];
    var locations_tab = [];
    var centerMapLat = parseFloat(map_config.hotel_info.latitude);
    var centerMapLong = parseFloat(map_config.hotel_info.longitude);


    function mannielloMap(locations_tab) {
        var bounds = new google.maps.LatLngBounds();

        // Center and zoom when the map is moved or zoomed
        if (window.innerWidth < 996) {
            // Different zoom if is mobile
            map.setZoom(14)
        } else {
            map.setZoom(map_config['map_zoom']);
        }
        map.panTo(new google.maps.LatLng(centerMapLat, centerMapLong));

        var i, marker, map_icon;

        for (i = 0; i < locations_tab.length; i++) {

            // Default Icon with check. Icons Big
            map_icon = (typeof locations_tab[i]['map_icon_big'] !== 'undefined') ? locations_tab[i]['map_icon_big'] : web_core + "/images/marker_small.png";

            marker = new google.maps.Marker({
                position: new google.maps.LatLng(locations_tab[i]['latitude'], locations_tab[i]['longitude']),
                map: map,
                icon: map_icon,
                animation: google.maps.Animation.DROP,
                title: locations_tab[i]['title'],
                // true is Hotel, false is others
                customIsHotel: locations_tab[i]['map_hotel']
            });

            markers.push(marker);

            // Extend the bounds including marker's position
            bounds.extend(marker.position);

            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                return function () {
                    map.panTo(marker.getPosition());

                    // Remove the http:.. or https:..
                    if (!!locations_tab[i]['map_web']) {
                        var regex = /^(?:https?:\/\/)?/i;
                        cleanUrl = locations_tab[i]['map_web'].replace(regex, "");
                    }

                    var contentInfo = '<div class="block-map-marker"><p class="text-bold title-infowindow">' + locations_tab[i]['title'] + '</p>';
                    if (locations_tab[i]['address'] || locations_tab[i]['map_phone'] || locations_tab[i]['map_fax'] || locations_tab[i]['map_email'] || locations_tab[i]['map_web']) contentInfo += '<div class="space-top-1">';

                    if (!!locations_tab[i]['address']) contentInfo += '<p><span class="text-bold">' + infowindow_address + ': </span>' + locations_tab[i]['address'] + '</p>';
                    if (!!locations_tab[i]['map_phone']) contentInfo += '<p><span class="text-bold">' + infowindow_phone + ': </span><a href="tel:' + locations_tab[i]['map_phone'] + '" class="link-green-color">' + locations_tab[i]['map_phone'] + '</a></p>';
                    if (!!locations_tab[i]['map_fax']) contentInfo += '<p><span class="text-bold">' + infowindow_fax + ': </span>' + locations_tab[i]['map_fax'] + '</p>';
                    if (!!locations_tab[i]['map_email']) contentInfo += '<p><span class="text-bold">' + infowindow_email + ': </span><a href="mailto:' + locations_tab[i]['map_email'] + '" class="link-green-color">' + locations_tab[i]['map_email'] + '</a></p>';
                    if (!!locations_tab[i]['map_web']) contentInfo += '<p><span class="text-bold">' + infowindow_web + ': </span><a href="' + locations_tab[i]['map_web'] + '" target="_blank" class="link-green-color">' + cleanUrl + '</a></p>';

                    if (locations_tab[i]['address'] || locations_tab[i]['map_phone'] || locations_tab[i]['map_fax'] || locations_tab[i]['map_email'] || locations_tab[i]['map_web']) contentInfo += '</div>';
                    contentInfo += '</div>';

                    infowindow.setContent(contentInfo);
                    infowindow.open(map, marker);

                }
            })(marker, i));
        }

        // Now fit the map
        map.fitBounds(bounds);

        // Zoom Out the map so the Hotels markers will be together
        zoomChangeBoundsListener =
            google.maps.event.addListenerOnce(map, 'bounds_changed', function (event) {
                if (this.getZoom() > 12) {
                    // console.log(this.getZoom());
                    this.setZoom(12);
                }
            });
        setTimeout(function () {
            google.maps.event.removeListener(zoomChangeBoundsListener)
        }, 2000);

        // Close the marker info window when is clicked on different parts of the map
        map.addListener('click', function () {
            if (infowindow) infowindow.close();
        });

        // Style for the cluster
        var styles = [{
            // Same background for every cluster
            url: web_core + "/images/cluster.png",
            height: 42,
            width: 42,
            className: 'style-cluster'
        }]

        markerCluster = new MarkerClusterer(map, markers, {
            // Change the min size to make cluster
            gridSize: 90,
            styles: styles
        });
    }

    function reloadMarkers() {

        locations_tab = [];

        // Close all the windows markers opened
        if (infowindow) infowindow.close();

        // Reset the markers array
        markers = [];

        // Locations is Hotels
        // Locations Exc is Excursions
        // Best performance speed with push and not using concat
        locations_tab.push(...locations_exc, ...locations);

        // Call set markers to re-add markers
        mannielloMap(locations_tab)

    }

    function intializedMap() {

        window.infowindow = new google.maps.InfoWindow;
        // The Center is automatic
        // var center = new google.maps.LatLng(map_config.markers[0].latitude, map_config.markers[0].longitude);
        var options = {
            // Disable the Fullscreen button
            fullscreenControl: false,
            // Scroll wheel
            scrollwheel: false,
            // center: center,
            zoomControl: map_config.map_zoom_control,
            zoomControlOptions: {
                position: google.maps.ControlPosition[map_config.zoom_control_position]
            },
            zoom: map_config['map_zoom'],
            mapTypeId: google.maps.MapTypeId[map_config.map_type],
            mapTypeControl: map_config.map_type_control,
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM,
                style: google.maps.MapTypeControlStyle.DEFAULT
            },
            // Default pan control
            panControl: false,
            panControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            },
            // Scale control - image with the scale index (m,km,etc)
            scaleControl: false,
            scaleControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT
            },
            // Streetview controls
            // streetViewControl: map_config.map_streetview_control,
            streetViewControl: false,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP,
            }
        }

        map = new google.maps.Map(mapBlock, options);

        reloadMarkers();

        // Custom style
        var styles = [{
            "featureType": "poi.business",
            "elementType": "all",
            "stylers": [{"visibility": "off"}]
        },
            {
                "featureType": "landscape.man_made",
                "stylers": [{"lightness": -15}]
            },]

        // Set custom styles on map
        map.setOptions({
            styles: styles
        });
    }

}
